import api from '@pray/shared/utils/api';

import type { MarketingCampaignTableView } from './getAllMarketingCampaigns';

export type GetMarketingCampaignByIdParams = {
  artistId: string;
  campaignId: string;
  // When 'performance', the endpoint also returns the per-campaign performance
  // block (daily series, leads/subs/trials counts, roi, cps/cpl) for the window.
  view?: MarketingCampaignTableView | null;
  dateRangeStart?: string | null;
  dateRangeEnd?: string | null;
};

export const getMarketingCampaignById = async ({
  artistId,
  campaignId,
  view = null,
  dateRangeStart = null,
  dateRangeEnd = null,
}: GetMarketingCampaignByIdParams) => {
  const params: Record<string, string> = {};
  if (view) params.view = view;
  if (dateRangeStart) params.date_range_start = dateRangeStart;
  if (dateRangeEnd) params.date_range_end = dateRangeEnd;

  const url = `/web/studio/artists/${artistId}/marketing-campaigns/${campaignId}`;
  const response = await api.executeGetRequest(url, params);

  return response.data;
};
